<template>
    <div>
        <div class="kgr-grid kgr-grid--gutters">
            <div class="kgr-grid__cell">
                <kgr-number-input
                    v-model="amountValue"
                    :label="$t('Betrag')"
                    @post-input="emitInput"
                />
            </div>
            <div class="kgr-grid__cell">
                <label
                    class="kgr-inputGroup"
                >
                    <div
                        class="kgr-inputGroup__label"
                    >
                        {{ $t('Zeitraum') }}
                    </div>
                    <kgr-generic-select
                        v-model="type"
                        display="text"
                        :disabled="fixedType"
                        :options="types"
                    />
                </label>
            </div>
        </div>
        <div class="kgr-grid kgr-grid--gutters">
            <div class="kgr-grid__cell">
                <kgr-generic-radio
                    v-model="netOrGross"
                    :options="netOrGrossOptions"
                    inline
                />
            </div>
            <div class="kgr-grid__cell">
                <kgr-number-input
                    v-model="vatPercentValue"
                    :label="$t('Steuersatz')"
                    :disabled="!vatChangeAllowed"
                />
            </div>
        </div>
    </div>
</template>

<script>
import GenericRadio from '../../common/form/radio/GenericRadio.vue';
import GenericSelect from '../../common/form/select/GenericSelect.vue';
import NumberInput from '../../common/form/input/NumberInput.vue';
import PricePerTime from '../../../js/dto/PricePerTime.js';

export default {
    components: {
        'kgr-number-input': NumberInput,
        'kgr-generic-select': GenericSelect,
        'kgr-generic-radio': GenericRadio,
    },
    props: {
        value: {
            type: PricePerTime,
            required: true,
        },
        amountDecimals: {
            type: Number,
            required: false,
            default: 2,
        },
        vatDecimals: {
            type: Number,
            required: false,
            default: 2,
        },
        fixedType: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            vatChangeAllowed: false, // will be removed with KIGAROO-5896
            vatPercentValue: 0,
            amountValue: 0,
            type: null,
            validations: { amount: true, vat: true },
            netOrGross: 'gross',
            netOrGrossOptions: {
                Brutto: 'gross',
                Netto: 'net',
            },
            types: [
                { value: 'oneTime', text: this.$t('einmalig') },
                { value: 'perDay', text: this.$t('pro Tag') },
                { value: 'perWeek', text: this.$t('pro Woche') },
                { value: 'perMonth', text: this.$t('pro Monat') },
                { value: 'perYear', text: this.$t('pro Jahr') },
            ],
        };
    },
    created() {
        const vatValue = this.value.vat.numerator / this.value.vat.denominator;
        this.vatPercentValue = Number((vatValue * 100).toFixed(this.vatDecimals));
        const amount = this.value.netOrGross === 'net' ? this.value.net : this.value.gross;
        this.amountValue = amount.numerator / amount.denominator;
        this.netOrGross = this.value.netOrGross;
        this.type = this.types.find((type) => type.value === this.value.type);
    },
    methods: {
        emitInput() {
            this.emitPricePerTime();
        },
        isValid() {
            return this.validations.amount && this.validations.vat;
        },
        validate(field, isValid) {
            this.validations[field] = isValid;
        },
        getNet() {
            const pow = 10 ** this.amountDecimals;
            let numerator = 1;
            let denominator = 1;
            if (this.value.netOrGross === 'gross') {
                numerator = 100 + this.vatPercentValue;
                denominator = 100;
            }
            return this.buildFraction(this.amountValue * pow * denominator, pow * numerator);
        },
        buildFraction(numerator, denominator) {
            return {
                data: {
                    numerator: Math.round(numerator),
                    denominator: Math.round(denominator),
                },
            };
        },
        getGross() {
            const pow = 10 ** this.amountDecimals;
            let denominator = 1;
            let numerator = 1;
            if (this.value.netOrGross === 'net') {
                numerator = 100 + this.vatPercentValue;
                denominator = 100;
            }
            return this.buildFraction(this.amountValue * pow * numerator, pow * denominator);
        },
        emitPricePerTime() {
            const powVat = 10 ** this.vatDecimals;

            const pricePerTime = PricePerTime.fromData({
                net: this.getNet(),
                gross: this.getGross(),
                vat: this.buildFraction(this.vatPercentValue * powVat, powVat * 100),
                type: this.value.type,
                currency: this.value.currency,
                netOrGross: this.netOrGross,
                valid: this.isValid(),
            });
            this.$emit('input', pricePerTime);
            this.$nextTick(() => {
                this.$emit('post-input', pricePerTime);
            });
        },
    },
};
</script>
